import request from 'api/requestUtils'

const PLACE_LOOKUP_TIMEOUT_MS = 10_000

export async function requestPlaceApi<T>(
  path: string,
  operationName: string,
): Promise<App.ApiResponse<T>> {
  const response = await request.get<App.ApiResponse<T>>(path, {
    timeout: PLACE_LOOKUP_TIMEOUT_MS,
  })
  if (!response) {
    throw new Error(`${operationName} returned no response`)
  }
  return response
}
